import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { ILogFile } from '../../../types/logs'
import { getContentDispositionFilename } from '../../../utils/getContentDispositionFilename'
import fileDownload from 'js-file-download'
import { getUrlWithVersion } from '../../../api/api'

export const downloadProductLogs = createAsyncThunk<
    void,
    { log: ILogFile },
    ThunkConfig<string>
>('logsSlice/downloadProductLogs', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { log } = args

    try {
        const res = await api.get(getUrlWithVersion(`/logs/${log.log_id}`), {
            responseType: 'blob',
        })

        if (res.status === 200) {
            const fileName = getContentDispositionFilename(res)
            fileDownload(res.data, fileName)
        }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to download product logs')
    }
})
